import React from 'react'
import { SearchField, Container, Button, Menu, MenuItem, Toolbar } from '@sencha/ext-modern'


function SearchBar(props) {
    const { handleChange, handleSearch, handleAdd, query, statusList, selectedStatus, handleSelectStatus } = props
    return (
        <Toolbar shadow={false} docked="top" padding="0" margin="0">
            {statusList && <Button align="left" iconCls="x-fa fa-bars" arrow={false}>
                <Menu>
                    {statusList.map((item, index) => (
                        <MenuItem key={index} text={item[0]} value={item[1]} iconCls={item[1] === selectedStatus ? "x-fa fa-circle" : "x-fa fa-circle-thin"} onClick={handleSelectStatus} />
                    ))}
                    <MenuItem text="全部" value={0} iconCls={selectedStatus == 0 ? "x-fa fa-circle" : "x-fa fa-circle-thin"} onClick={handleSelectStatus} />
                </Menu>
            </Button>}
            <SearchField ui="faded" placeholder="" margin="0 20 0 20" value={query} onChange={handleChange} width="220px" />
            <Container layout="center">
                <Button iconCls="x-fa fa-search" text="" handler={() => handleSearch()} />
            </Container>
            {handleAdd && <Container layout="center">
                <Button iconCls="x-fa fa-plus" text="" handler={handleAdd} />
            </Container>}
        </Toolbar>
    )
}
export default SearchBar

